import React, { memo } from "react";

import { TableContainer } from "../Table/index.jsx";
import GridSelect from "../GridSelect.jsx";
import ColorPicker from "../ColorPicker.jsx";
import Select from "../Select.jsx";

const FONT_SIZE_OPTIONS = [12,14,16,18,20,22,24,30,36].map(s => ({label: s, value: s}));

const FONT_WEIGHT_OPTIONS = [
  {label: 'Extra bold', value: 800},
  {label: 'Bold', value: 600},
  {label: 'Normal', value: 400},
  {label: 'Thin', value: 200},
]


const HeadingConfiguration = memo(({headings, updateCell}) => {

  const CheckboxCell = ({value, updateCell, row: {id: index}, column: {id}}) => <div className="justify-center"><input 
    type='checkbox'  
    checked={value} 
    onChange={e => updateCell('headings', index, id, !value)} 
  /></div>

  const SelectCell = ({value, updateCell, row: {id: index}, column: {id}, options}) => <GridSelect 
    options={options} 
    value={value} 
    menuPortalTarget={document.body} 
    onChange={(val) => updateCell('headings', index, id, val)}
  />

  const ColorPickerCell = ({ value, updateCell, row: {id: index}, column: {id}, options}) => <ColorPicker
    inputProps={{
      className: "",
      style: {border: 'none', outline: 'none', backgroundColor: 'transparent'}
    }}
    value={value}
    onChange={val => updateCell('headings', index, id, val)}
  />


  const columnDefs = React.useMemo(
    () => [
      {
        Header: I18n.t('level'),
        id: 'level',
        Cell: ({row: {id}}) => id,
        disableSortBy: true,
        width: 50,
      },
      {
        Header: I18n.t('background_color'),
        accessor: 'bg',
        Cell: ColorPickerCell,
        disableSortBy: true,
        width: 130,
      },
      {
        Header: I18n.t('text_color'),
        accessor: 'color',
        Cell: ColorPickerCell,
        disableSortBy: true,
        width: 80,
      },
      {
        Header: I18n.t('font_size'),
        accessor: 'size',
        Cell: (props) => <SelectCell {...props} options={FONT_SIZE_OPTIONS} />,
        disableSortBy: true,
        width: 75,
      },
      {
        Header: I18n.t('font_weight'),
        accessor: 'weight',
        Cell: (props) => <SelectCell {...props} options={FONT_WEIGHT_OPTIONS} />,
        disableSortBy: true,
        width: 100,
      },
      {
        Header: I18n.t('italic'),
        accessor: 'italic',
        Cell: CheckboxCell,
        disableSortBy: true,
        width: 80,
        headerClasses: 'text-center',
      },
      {
        Header: I18n.t('underline'),
        accessor: 'underline',
        Cell: CheckboxCell,
        disableSortBy: true,
        width: 80,
        headerClasses: 'text-center',
      },
      {
        Header: I18n.t('all_caps'),
        accessor: 'upcase',
        Cell: CheckboxCell,
        disableSortBy: true,
        width: 80,
        headerClasses: 'text-center',
      },
    ]
  )

  return <TableContainer
    columns={columnDefs}
    data={Object.values(headings)}
    maxHeight={false}
    isFixedSize={true}
    tableProps={{
      updateCell,
    }}
  />
})

export default HeadingConfiguration;